module.exports = __webpack_public_path__ + "assets/3ae7ad53fd376332c9cce3ae01e86c76.mp3";